
import { useEffect, useState } from 'react'
import useSSE from '../../useSSE';
import axios from 'axios';
import { setToken, clearToken } from '../../auth';

import { useNavigate,Link, NavLink } from "react-router-dom";
import { FaBars,FaUserPlus, FaHome, FaLock, FaMoneyBill, FaUser,FaUsers, FaEye, FaEyeSlash, FaRobot, FaMoon, FaSun, FaShieldAlt, FaChartLine, FaChevronDown, FaWhatsapp, FaPhoneVolume, FaTachometerAlt, FaVideo, FaUpload } from "react-icons/fa";
import { MdMessage } from "react-icons/md";
import { BiAnalyse, BiSearch } from "react-icons/bi";

import { RiLoginCircleLine } from "react-icons/ri";
import { BiCog } from "react-icons/bi";
import { MdAudiotrack } from "react-icons/md";
import { MdOutlineAudioFile } from "react-icons/md";

import { AiFillHeart, AiTwotoneFileExclamation,AiOutlineForm } from "react-icons/ai";
import { BsDatabaseFillDown } from "react-icons/bs";

import { BsCartCheck } from "react-icons/bs";
import { AiOutlineLogout } from "react-icons/ai";
import { IoMdTimer } from "react-icons/io";
import { FcCallback } from "react-icons/fc";


import { MdCampaign } from "react-icons/md";
import { TbReportSearch } from "react-icons/tb";
import { FcManager } from "react-icons/fc";


import logo from '../../images/profile.png';
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";
import { showSuccess, showError } from '../../toast';
import { subscribeUserInfo, refreshUserInfoNow } from '../../userInfoStore';
import useJitsiAccess from '../../pages/jitsi/useJitsiAccess';
import useLiveKitAccess from '../../pages/livekit/useLiveKitAccess';
import WebRTCClient from '../../pages/WebRTCClient';
import { parsePermissions } from '../../teamLeaderPages';
import { ADMIN_PAGES } from '../../adminPages';
import { hasAnyVisibleSettings } from '../../settingsCatalog';
import { useLocation } from 'react-router-dom';
import { PiPasswordFill, PiTreeStructureFill } from "react-icons/pi";
import { FaUserShield, FaBan, FaListOl } from "react-icons/fa";

import { RiLockPasswordFill } from "react-icons/ri";

import { FaSms } from "react-icons/fa";
import { PiPhoneTransfer } from "react-icons/pi";
import { FiFileText } from "react-icons/fi";
import Breadcrumb from '../Breadcrumb';



//localStorage.getItem('roles') === 'ROLE_ADMIN'?`name: "Users"`:`name: "Users"`







// useEffect(() => {
  
// }, [])



const styleObj = {
  textDecoration: "none !important"
}

// Agent CRM call-connect/disconnect beep — two independent SUPERADMIN
// toggles per admin (json.beepOnCall / json.beepOnHangup), sharing one
// volume (see DialerSettings.jsx / /Admin/SetBeepOwnerSetting). Fired on
// the FREE->BUSY transition (call connected) and the reverse BUSY->FREE
// transition (call disconnected, by either party, inbound or outbound) —
// see the two call sites below — so it plays regardless of which page the
// agent is currently on. volumePct is 0-100 (from json.beepVolume); a
// GainNode applies it as gain (0-1).
const playBeep = (volumePct) => {
  try {
    const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
    const audioContext = new AudioContextCtor();
    const oscillator = audioContext.createOscillator();
    const gain = audioContext.createGain();
    const pct = typeof volumePct === 'number' ? volumePct : 70;
    gain.gain.setValueAtTime(Math.max(0, Math.min(100, pct)) / 100, audioContext.currentTime);
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(300, audioContext.currentTime);
    oscillator.connect(gain);
    gain.connect(audioContext.destination);
    // A freshly created AudioContext can start 'suspended' under the
    // browser's autoplay policy even after prior user interaction on the
    // page (e.g. the agent's own login click) — resume() is a no-op if
    // already running, so this is safe to always call.
    if (audioContext.state === 'suspended') audioContext.resume().catch(() => {});
    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.1);
  } catch (err) {
    // Browser may block AudioContext before a user gesture — non-fatal.
  }
};



const SideBar = ({ children }) => {



  const location = useLocation();

  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const checkMobile = () => {
      setIsOpen(window.innerWidth > 768);
    };

    checkMobile();

   

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [location.pathname]);



// Single subscription to the shared userInfo store. Handles both the
// auto-logout check and (further down) the username display, so SideBar
// no longer issues its own /User/GetUserinfo request.
useEffect(() => {
  let prevStatus = null;
  const unsubscribe = subscribeUserInfo((json) => {
    if (!json || !json.userpro) return;
    // Skip the auto-logout while an impersonation session is active —
    // an ADMIN viewing a USER hasn't actually signed the user in, so
    // their loginstatus is naturally "LOGOUT" and would otherwise trip
    // this guard and bounce the impersonator back to the login screen.
    const isImpersonating = !!localStorage.getItem('originalRoles');
    if (!isImpersonating
            && json.userpro.loginstatus === "LOGOUT"
            && localStorage.getItem('roles') === 'ROLE_USER') {
      localStorage.removeItem('token');
      localStorage.removeItem('roles');
      setLogin(true);
      setSidebar(false);
      setCredentials({ username: "", password: "" });
      history('/Dashboard');
      showSuccess("Successfully Logout");
    }
    if (json.username) setUsernamed(json.username);
    if (localStorage.getItem('roles') === 'ROLE_USER') {
      if (json.userpro.userid) setUseridforlogo(json.userpro.userid);
      if (json.userpro.sip) setSipForPhone(json.userpro.sip);
      // Screen-pop: navigate to CRM as soon as status transitions to BUSY
      const st = json.userpro.status;
      if (st === 'BUSY' && prevStatus !== 'BUSY') {
        if (json.beepOnCall) playBeep(json.beepVolume);
        if (window.location.pathname !== '/Crm') history('/Crm');
      }
      // Disconnect beep: BUSY->(anything else) covers both directions
      // (incoming/outbound) and either party hanging up — the PBX-driven
      // status flips to FREE the same way regardless of who ended the call.
      // Independent toggle from the connect beep above (json.beepOnCall).
      if (prevStatus === 'BUSY' && st !== 'BUSY') {
        if (json.beepOnHangup) playBeep(json.beepVolume);
      }
      prevStatus = st;
    }
    if (localStorage.getItem('roles') === 'ROLE_ADMIN') {
      if (json.userpro && json.userpro.sip) setSipForPhone(json.userpro.sip);
      setAdminPermissions(parsePermissions(json.pagePermissions));
    }
    if (localStorage.getItem('roles') === 'ROLE_TEAMLEADER') {
      setTlPermissions(parsePermissions(json.pagePermissions));
      if (json.userpro && json.userpro.sip) setSipForPhone(json.userpro.sip);
    }
    if (localStorage.getItem('roles') === 'ROLE_OBDADMIN') {
      // Same pagePermissions CSV pattern as ROLE_ADMIN — superadmin grants
      // these per-user via AdminPermissions. Each granted path unlocks the
      // matching sidebar row below (see OBDADMIN_GRANTABLE).
      setObdAdminPermissions(parsePermissions(json.pagePermissions));
    }
    if (localStorage.getItem('roles') === 'ROLE_OBDUSER') {
      // Mirror the three self-serve flags set by the parent OBDADMIN via
      // /Obd/SetObdUserPermissions. Used to conditionally append matching
      // entries to routesobduser below.
      setObdUserSelfServe({
        campaign: !!json.obdAllowCampaign,
        uploadNumber: !!json.obdAllowUploadNumber,
        uploadAudio: !!json.obdAllowUploadAudio,
      });
    }
    setAllowWebphone(!!json.allowWebphone);
  }, 10000);
  return unsubscribe;
}, []);



// Get CallBack Notification
const [totalcallback, setTotalcallback] = useState()

// SSE pushes callback count on change; falls back to 30s polling
useSSE(
  '/SSE/CallbackCount',
  'callbackcount',
  (data) => {
    const count = typeof data === 'number' ? data : (data.count ?? 0);
    setShowNotification(count > 0);
    setTotalcallback(count);
  },
  async (signal) => {
    if (!localStorage.getItem('roles')) return;
    try {
      const res = await axios.get(process.env.REACT_APP_IP + `/User/CountActiveCallBack`,
        { withCredentials: true, signal });
      const count = res.data;
      setShowNotification(count > 0);
      setTotalcallback(count);
    } catch (err) { /* silently ignore */ }
  },
  30000,
  []
)



  const [showNotification, setShowNotification] = useState(false);

  // useEffect(() => {
  //   setShowNotification(true);

  //   // setTimeout(() => {
  //   //   setShowNotification(false);
  //   // }, 3000);
  // },[])




  const[usernamed, setUsernamed] = useState('')
  const[useridforlogo, setUseridforlogo] = useState('')
  const[sipForPhone, setSipForPhone] = useState('')
  const[allowWebphone, setAllowWebphone] = useState(false)
  const[sipPassword, setSipPassword] = useState('')

  // Fetch the real WebRTC/SIP password once the softphone is actually going
  // to render (same gating as the <WebRTCClient> render condition below) —
  // not derived client-side anymore, and not refetched on every userInfo tick.
  useEffect(() => {
    const role = localStorage.getItem('roles');
    const willRenderPhone = allowWebphone && sipForPhone && (role === 'ROLE_USER' || role === 'ROLE_ADMIN');
    if (!willRenderPhone || sipPassword) return;
    (async () => {
      try {
        const res = await fetch(process.env.REACT_APP_IP + '/User/GetSipCredentials', { credentials: 'include' });
        const json = await res.json();
        if (json && json.password) setSipPassword(json.password);
      } catch (e) { console.error('GetSipCredentials failed:', e); }
    })();
  }, [allowWebphone, sipForPhone, sipPassword]);
  const[tlPermissions, setTlPermissions] = useState([])
  const[adminPermissions, setAdminPermissions] = useState([])
  const[obdAdminPermissions, setObdAdminPermissions] = useState([])
  const[obdUserSelfServe, setObdUserSelfServe] = useState({ campaign:false, uploadNumber:false, uploadAudio:false })
  // Cascade-RBAC for the Video tab. useJitsiAccess dedupes the poll across
  // the sidebar and every open Video page — one request per refresh cycle
  // no matter how many components care. The tab vanishes when an ancestor
  // revokes the grant.
  const videoAccessState = useJitsiAccess('jitsi.video')
  const videoAccess = videoAccessState.granted
  // Same cascade-RBAC pattern as the Video tab above, for the LiveKit
  // calling feature (VoiceBotSettings.liveKitCallingEnabled grant).
  const liveKitAccessState = useLiveKitAccess()
  const liveKitAccess = liveKitAccessState.granted
  const filterRoutes = (arr) => arr.filter(r => !r.feature
    || (r.feature === 'jitsi.video' && videoAccess)
    || (r.feature === 'livekit.calling' && liveKitAccess))


  const[mmuser,setUser] = useState("")
useEffect(() => {

  if (localStorage.getItem('roles')==='ROLE_ADMIN')
   {
    setUser("Users")

  } else {
    setUser("")
}
  
  
  
}, [])
// Admin role
const routes = [
  {
    path: "/",
    name: "Dashboard",
    icon: <FaHome />,
  },
  {
    path: "/Realtime",
    name: "Realtime",
    icon: <IoMdTimer />,
  },
   
  {
    path: "/Users",
    name: "Users",
    icon: <FaUserPlus />,
    exact: true,
    subRoutes: [
      {
        path: "/Users",
        name: "Add User",
        icon: <FaUserPlus />,
      },
      {
        path: "/TeamLeaders",
        name: "Permission",
        icon: <FcManager />,
      },
    ],
  },

  // Read-only Free/Dialing/Busy gatewayport dashboard — visible in the nav
  // for every role that could plausibly have access; the page itself shows
  // a "not enabled" message if the ChannelStatusAccess grant is missing
  // (fail-closed on the backend, see ChannelStatusController).
  {
    path: "/ChannelStatus",
    name: "Channel Status",
    icon: <FaPhoneVolume />,
  },

  // Wave-1 Slice-B: Skills promoted to a top-level entry for ADMIN /
  // TEAMLEADER / OBDADMIN. The old Skills + SupervisorSkills sub-rows
  // under Users were removed; SupervisorSkills route still redirects
  // to /Skills?tab=live so bookmarks keep working.
  {
    path: "/Skills",
    name: "Skills",
    icon: <FaTachometerAlt />,
    exact: true,
    subRoutes: [
      { path: "/Skills?tab=live",      name: "Live Monitor",  icon: <FaEye /> },
      { path: "/Skills?tab=agents",    name: "Agent Skills",  icon: <FaUsers /> },
      { path: "/Skills?tab=queues",    name: "Queue Routing", icon: <FaPhoneVolume /> },
      { path: "/Skills?tab=campaigns", name: "Campaigns",     icon: <MdCampaign /> },
      { path: "/Skills?tab=catalog",   name: "Catalog",       icon: <FiFileText /> },
      { path: "/Skills?tab=reports",   name: "Reports",       icon: <FaChartLine /> },
      { path: "/Skills?tab=simulator", name: "Simulator",     icon: <BiAnalyse /> },
    ],
  },

  {
    path: "/Video",
    name: "Video",
    icon: <FaVideo />,
    feature: "jitsi.video",
    exact: true,
    subRoutes: [
      { path: "/Video/Dashboard",  name: "Dashboard",   icon: <FaVideo /> },
      { path: "/Video/NewMeeting", name: "New Meeting", icon: <FaVideo /> },
      { path: "/Video/Escalate",   name: "Escalate Call", icon: <FaVideo /> },
      { path: "/Video/MyRooms",    name: "My Rooms",    icon: <FaVideo /> },
      { path: "/Video/Recordings", name: "Recordings",  icon: <FaVideo /> },
      { path: "/Video/LiveMonitor",name: "Live Monitor",icon: <FaVideo /> },
    ],
  },

  {
    path: "/LiveKit/Call",
    name: "LiveKit Calling",
    icon: <FaPhoneVolume />,
    feature: "livekit.calling",
  },

 {
  path: "/AddCampaign",
  name: "AutoCall",
  icon: <MdCampaign />,
  exact: true,
  subRoutes: [
   
    {
      path: "/AddCampaign",
      name: "AddCampaign",
      icon: <AiOutlineForm />,
    },
    {
      path: "/Makegui",
      name: "MakeCrm",
      icon: <AiOutlineForm />,
    },
    {
      path: "/Assignlist",
      name: "AssignList",
      icon: <AiOutlineForm />,
    },
    {
      path: "/Assignagent",
      name: "Assignagent",
      icon: <AiOutlineForm />,
    },
    {
      path: "/CampDid",
      name: "CampDid",
      icon: <AiOutlineForm />,
    },
    {
      path: "/AddDisposition",
      name: "Disposition",
      icon: <AiOutlineForm />,
    },
    {
      path: "/CampaignScript",
      name: "CampaignScript",
      icon: <FiFileText />,
    },
    {
      // ?tab=autocall distinguishes this from the Voice-Bot "Upload Number"
      // entry below, which points at the same page/pathname — without a
      // query-string difference, isSubRouteActive() (SidebarMenu.jsx) can't
      // tell them apart and both light up active together. permPath is set
      // explicitly (was implicitly s.path before) so the added query string
      // doesn't change what's checked against the admin's permission list.
      path: "/UploadNumber?tab=autocall",
      permPath: "/UploadNumber",
      name: "UploadNumber",
      icon: <BsDatabaseFillDown />,
    },
    {
      path: "/UploadAudio",
      name: "UploadAudio",
      icon: <MdOutlineAudioFile />,
    },
    {
      path: "/MusicOnHold",
      name: "Music On Hold",
      icon: <MdAudiotrack />,
    },
    {
      path: "/ChurnLeads",
      name: "ChurnLeads",
      icon: <AiOutlineForm />,
    },

  ],
},

{
  path: "/VoiceBot",
  name: "Voice-Bot",
  icon: <FaRobot />,
  exact: true,
  subRoutes: [
    {
      path: "/VoiceBot",
      name: "Add Campaign",
      icon: <FaRobot />,
    },
    {
      // Same page as AutoCall's "UploadNumber" entry above, but gated by
      // its own permission key (permPath) so a superadmin can grant this
      // Voice-Bot placement without also exposing the AutoCall submenu —
      // the two entries would otherwise share the plain /UploadNumber
      // permission and always show/hide together. ?tab=voicebot keeps the
      // active-highlight independent of the AutoCall entry too (see its
      // comment above).
      path: "/UploadNumber?tab=voicebot",
      permPath: "/VoiceBotUploadNumber",
      name: "Upload Number",
      icon: <BsDatabaseFillDown />,
    },
    {
      path: "/VoiceBotKnowledgeBase",
      name: "Knowledge Base",
      icon: <FaRobot />,
    },
    {
      path: "/VoiceBotTools",
      name: "Tools",
      icon: <FaRobot />,
    },
    {
      path: "/VoiceBotCallLogs",
      name: "Call Logs",
      icon: <FaRobot />,
    },
    {
      path: "/VoiceBotConversions",
      name: "Scheduled Visits",
      icon: <FaRobot />,
    },
    {
      path: "/VoiceBotSettings",
      name: "Settings",
      icon: <FaRobot />,
    },
    {
      path: "/VoiceBotQuotas",
      name: "Minutes Quota",
      icon: <FaRobot />,
    },
    {
      path: "/VoiceBotAccess",
      name: "Access",
      icon: <FaRobot />,
    },
  ],
},

{
  path: "/Messaging",
  name: "Messaging",
  icon: <MdMessage />,
  exact: true,
  subRoutes: [
    {
      path: "/Messaging",
      name: "Send Message",
      icon: <MdMessage />,
    },
    {
      path: "/MessagingSettings",
      name: "Settings",
      icon: <BiCog />,
    },
  ],
},

  {
    path: "/Report",
    name: "Reports",
    icon: <BsDatabaseFillDown />,
    exact: true,
    subRoutes: [

      {
        path: "/Reportlive",
        name: "Reportlive",
        icon: <TbReportSearch />,
      },
      {
        path: "/Report",
        name: "AllReports",
        icon: <TbReportSearch />,
      },
      {
        path: "/FilterReport",
        name: "FilterReport",
        icon: <TbReportSearch />,
      },
      {
        path: "/FilterReportold",
        name: "FilterReportold",
        icon: <TbReportSearch />,
      },
      {
        path: "/Agentlog",
        name: "Agentlog",
        icon: <TbReportSearch />,
      },
      {
        path: "/AgentPerformance",
        name: "AgentPerformance",
        icon: <TbReportSearch />,
      },
      {
        path: "/BreakReport",
        name: "BreakReport",
        icon: <TbReportSearch />,
      },
      {
        path: "/Callbackreport",
        name: "CallBackReport",
        icon: <FcCallback />,
      },

    ],
  },

  // {
  //   path: "/messages",
  //   name: "Messages",
  //   icon: <MdMessage />,
  // },
  // {
  //   path: "/analytics",
  //   name: "Analytics",
  //   icon: <BiAnalyse />,
  // },
  // {
  //   path: "/file-manager",
  //   name: "Report",
  //   icon: <AiTwotoneFileExclamation />,
  //   subRoutes: [
  //     {
  //       path: "/CallLog",
  //       name: "CallLog ",
  //       icon: <FaUser />,
  //     },
  //     {
  //       path: "/IvrReport",
  //       name: "IVR Report",
  //       icon: <FaUser />,
  //     },
  //   ],
  // },
  // {
  //   path: "/order",
  //   name: "Order",
  //   icon: <BsCartCheck />,
  // },
  {
    path: "/settings",
    name: "Settings",
    icon: <BiCog />,
  },

  {
    path: "/Smssuits",
     name: "SMS Suits",
     icon: <FaSms size="24" />,
    exact: true,
    subRoutes: [
      {
    

        path: "/Smssuits",
       // path: mmuser,
        name: "SMS Suits",
        icon: <FaSms size="24" />,
       // icon: mmuser,
      },
      {
        path: "/SmsportSetting",
        name: "SmsportSetting",
        icon: <BiCog />,
      },
    ],

  },
  
  

  
{
  path: "/AddAgent",
  name: "IVR",
  icon: <PiTreeStructureFill />,
  exact: true,
  subRoutes: [
    { path: "/Group",         name: "IVR Group",  icon: <FaUsers /> },
    { path: "/IvrGroupAssignAgent", name: "Assign Agent", icon: <FaUserPlus /> },
    { path: "/AddAgent",      name: "IVR Agent",  icon: <FaUserPlus /> },
    { path: "/DrawIvr",       name: "Draw IVR",   icon: <PiTreeStructureFill /> },
    { path: "/IvrReport", name: "IVR Report", icon: <TbReportSearch /> },
    { path: "/IvrSmsReport",  name: "SMS Report", icon: <FaSms /> },
  ],
},

{
  path: "/Logout",
  name: "Logout",
  icon: <AiOutlineLogout />,
},
];
 






const routessuperadmin = [
  {
    path: "/",
    name: "Dashboard",
    icon: <FaHome />,
  },
   
   {
     path: "/Users",
    name: "Clients",
     icon: <FaUserPlus />,
  },
  {
    path: "/AdminPermissions",
    name: "Admin Permission",
    icon: <FaUserShield />,
  },
  // Wave-1 Slice-B: Skills + SupervisorSkills collapsed into a single
  // top-level entry. Supervisor view is now /Skills?tab=live (the
  // SupervisorSkills route still works as a redirect for old bookmarks).
  {
    path: "/Skills",
    name: "Skills",
    icon: <FaTachometerAlt />,
    exact: true,
    subRoutes: [
      { path: "/Skills?tab=live",      name: "Live Monitor",  icon: <FaEye /> },
      { path: "/Skills?tab=agents",    name: "Agent Skills",  icon: <FaUsers /> },
      { path: "/Skills?tab=queues",    name: "Queue Routing", icon: <FaPhoneVolume /> },
      { path: "/Skills?tab=campaigns", name: "Campaigns",     icon: <MdCampaign /> },
      { path: "/Skills?tab=catalog",   name: "Catalog",       icon: <FiFileText /> },
      { path: "/Skills?tab=reports",   name: "Reports",       icon: <FaChartLine /> },
      { path: "/Skills?tab=simulator", name: "Simulator",     icon: <BiAnalyse /> },
      { path: "/Skills?tab=grants",    name: "Grants",        icon: <FaShieldAlt /> },
    ],
  },
  {
    path: "/GeminiVoiceCatalog",
    name: "Gemini Voice Catalog",
    icon: <FiFileText />,
  },
  {
    path: "/AngularBuildUpload",
    name: "Angular Build Upload",
    icon: <FaUpload />,
  },
  {
    path: "/Video",
    name: "Video",
    icon: <FaVideo />,
    feature: "jitsi.video",
    exact: true,
    subRoutes: [
      { path: "/Video/Dashboard",  name: "Dashboard",   icon: <FaVideo /> },
      { path: "/Video/NewMeeting", name: "New Meeting", icon: <FaVideo /> },
      { path: "/Video/Escalate",   name: "Escalate Call", icon: <FaVideo /> },
      { path: "/Video/MyRooms",    name: "My Rooms",    icon: <FaVideo /> },
      { path: "/Video/Recordings", name: "Recordings",  icon: <FaVideo /> },
      { path: "/Video/LiveMonitor",name: "Live Monitor",icon: <FaVideo /> },
    ],
  },
  {
    path: "/LiveKit/Call",
    name: "LiveKit Calling",
    icon: <FaPhoneVolume />,
    feature: "livekit.calling",
  },
  {
    path: "/MessagingSettings",
    name: "Messaging",
    icon: <MdMessage />,
  },
  {
    path: "/Resellers",
    name: "Resellers",
    icon: <FaUserPlus />,
  },
  // {
  //   path: "/messages",
  //   name: "Messages",
  //   icon: <MdMessage />,
  // },
  // {
  //   path: "/analytics",
  //   name: "Analytics",
  //   icon: <BiAnalyse />,
  // },
  {
    path: "/file-manager",
    name: "Report",
    icon: <AiTwotoneFileExclamation />,
    subRoutes: [
      {
        path: "/Reportlive",
        name: "Reportlive",
        icon: <TbReportSearch />,
      },
      {
        path: "/Report",
        name: "AllReports",
        icon: <TbReportSearch />,
      },
      // {
      //   path: "/FilterReport",
      //   name: "FilterReport",
      //   icon: <TbReportSearch />,
      // },
      {
        path: "/Agentlog",
        name: "Agentlog",
        icon: <TbReportSearch />,
      },
      {
        path: "/PasswordChangeLogs",
        name: "Password Audit Log",
        icon: <TbReportSearch />,
      },
      {
        path: "/SuperAdminActivityLog",
        name: "Activity Log",
        icon: <TbReportSearch />,
      },

    ],
  },
  // {
  //   path: "/order",
  //   name: "Order",
  //   icon: <BsCartCheck />,
  // },
  {
    path: "/NetworkMonitor",
    name: "Network & Internet",
    icon: <FaChartLine />,
  },
  {
    path: "/DncSettings",
    name: "DNC Check",
    icon: <FaBan />,
  },
  {
    path: "/settings",
    name: "Settings",
    icon: <BiCog />,
  },
  {
    path: "/Logout",
    name: "Logout",
    icon: <AiOutlineLogout />,
  },
  // {
  //   path: "/saved",
  //   name: "Saved",
  //   icon: <AiFillHeart />,
  // },
];

// RESELLER menu — SUPERADMIN-shaped slice capped by Resellerquota. Drops
// tenant-infra entries (SmsportSetting, AllowIP/Port, Fail2ban, PJSIP
// endpoints, OBD dialer settings, ApproveAudio, AdminPermissions) since
// the backend gates those SUPERADMIN-only; keeps Users, channel + DID
// assignment, reports, and MyQuota so the reseller can provision and see
// utilisation within their cap.
const routesreseller = [
  { path: "/",            name: "Dashboard", icon: <FaHome /> },
  { path: "/Users",       name: "Clients",   icon: <FaUserPlus /> },
  { path: "/MyQuota",     name: "My Quota",  icon: <FaUserShield /> },
  { path: "/ChannelStatus", name: "Channel Status", icon: <FaPhoneVolume /> },
  { path: "/MyResellers", name: "My Resellers", icon: <FaUsers /> },
  { path: "/MyVoiceBotAccess", name: "VoiceBot Access", icon: <FaRobot /> },
  { path: "/MyMessagingAccess", name: "Messaging Access", icon: <FaWhatsapp /> },
  { path: "/MyChannelStatusAccess", name: "Channel Status Access", icon: <FaChartLine /> },
  { path: "/MyAdminPermissions", name: "Admin Permissions", icon: <FaLock /> },
  {
    path: "/file-manager",
    name: "Reports",
    icon: <AiTwotoneFileExclamation />,
    subRoutes: [
      { path: "/Reportlive", name: "Reportlive", icon: <TbReportSearch /> },
      { path: "/Report",     name: "AllReports", icon: <TbReportSearch /> },
      { path: "/Agentlog",   name: "Agentlog",   icon: <TbReportSearch /> },
      { path: "/SuperAdminActivityLog", name: "Activity Log", icon: <TbReportSearch /> },
    ],
  },
  {
    path: "/settings",
    name: "Settings",
    icon: <BiCog />,
  },
  { path: "/Logout", name: "Logout", icon: <AiOutlineLogout /> },
];


const routagent = [
  {
    path: "/",
    name: "Dashboard",
    icon: <FaHome />,
  },

  {
    path: "/file-manager",
    name: "Report",
    icon: <AiTwotoneFileExclamation />,
    subRoutes: [
      {
        path: "/CallLog",
        name: "CallLog ",
        icon: <FaUser />,
      },
      {
        path: "/IvrReport",
        name: "IVR Report",
        icon: <FaUser />,
      },
    ],
  },
  {
    path: "/ChangePwd",
    name: "Pwdchange",
    icon: <FaLock />,
  },
  {
    path: "/Logout",
    name: "Logout",
    icon: <AiOutlineLogout />,
  },
];






const routesobdadmin = [
  {
    path: "/",
    name: "Dashboard",
    icon: <FaHome />,
  },
  {
    path: "/Users",
    name: "AddClient",
    icon: <FaUserPlus />,
  },
  {
    path: "/AddObdCampaign",
    name: "AddCampaign",
    icon: <BiCog />,
  },
  {
    path: "/ObdFlowList",
    name: "CallFlow",
    icon: <PiTreeStructureFill />,
  },
  {
    path: "/ObdReport",
    name: "Report",
    icon: <BsDatabaseFillDown />,
  },
  {
    path: "/ObdUserPermissions",
    name: "User Permissions",
    icon: <FaLock />,
  },
  {
    path: "/settings",
    name: "Settings",
    icon: <BiCog />,
  },
  {
    path: "/ObdProfile",
    name: "Profile",
    icon: <FaUser />,
  },
  {
    path: "/Logout",
    name: "Logout",
    icon: <AiOutlineLogout />,
  },
];


/**
 * Icon lookup for paths the superadmin might grant to an OBDADMIN. Paths
 * not listed here fall back to a generic cog so a new ADMIN_PAGES entry
 * automatically surfaces on the OBDADMIN sidebar without another edit.
 */
const OBDADMIN_ICON_OVERRIDES = {
  "/VoiceBot": <FaRobot />,
  "/VoiceBotKnowledgeBase": <FaRobot />,
  "/VoiceBotTools": <FaRobot />,
  "/VoiceBotCallLogs": <FaRobot />,
  "/VoiceBotConversions": <FaRobot />,
  "/VoiceBotSettings": <FaRobot />,
  "/VoiceBotQuotas": <FaRobot />,
  "/Users": <FaUserPlus />,
  "/TeamLeaders": <FaUsers />,
  "/ChangePwd": <FaLock />,
  "/": <FaHome />,
};

/**
 * Full catalog of pages a superadmin can grant to an OBDADMIN — sourced
 * directly from adminPages.js so nothing gets missed. An entry only shows
 * up in the rendered sidebar if its path is in the user's pagePermissions
 * CSV (see filter logic in the ROLE_OBDADMIN render block below). The
 * `group` field is preserved so granted pages from the same ADMIN_PAGES
 * group can be re-nested under a single parent menu (e.g. four granted
 * IVR pages collapse into one "IVR" submenu rather than four flat rows).
 */
const OBDADMIN_GRANTABLE = ADMIN_PAGES.map(p => ({
  path: p.path,
  name: p.label,
  group: p.group,
  icon: OBDADMIN_ICON_OVERRIDES[p.path] || <BiCog />,
}));

/**
 * Group-level meta for the OBDADMIN sidebar: parent menu name + icon used
 * when 1+ pages from the same ADMIN_PAGES group are granted. Groups not
 * listed here (or "Main") render flat at the top level. Keep in sync with
 * the `group` field in adminPages.js.
 */
// Note: 'Settings' is deliberately absent — grants tagged group:'Settings'
// are surfaced only via the Settings hub page (settingsCatalog.js), not as
// a second sidebar submenu. See the 'Settings' skip in the merge loop below.
const OBDADMIN_GROUP_META = {
  'Users':         { name: 'Users',         icon: <FaUsers /> },
  'Campaign':      { name: 'AutoCall',      icon: <MdCampaign /> },
  'Voice-Bot':     { name: 'Voice-Bot',     icon: <FaRobot /> },
  'Messaging':     { name: 'Messaging',     icon: <MdMessage /> },
  'Reports':       { name: 'Reports',       icon: <BsDatabaseFillDown /> },
  'SMS':           { name: 'SMS',           icon: <FaSms /> },
  'IVR':           { name: 'IVR',           icon: <PiTreeStructureFill /> },
};


// OBDUSER base menu — workflow order:
//   1. Operate (AddAgent, BlockNumber)
//   2. Review  (Report)
//   3. Account (Profile, Pwdchange, Logout)
// When the parent OBDADMIN flips a self-serve flag, the matching entries
// are injected at the TOP of the list in dependency order
// (audio → number → campaign) so the supporting actions appear before the
// campaign that consumes them. See the OBDUSER render block below.
const routesobduser = [
  // CallFlow is always available to OBDUSER (own flows only) — no self-serve
  // flag gate, since drawing a flow is harmless without a linked campaign.
  { path: "/ObdFlowList",    name: "CallFlow",    icon: <PiTreeStructureFill />},
  { path: "/AddObdAgent",    name: "AddAgent",    icon: <FaUserPlus />        },
  { path: "/ObdBlockNumber", name: "BlockNumber", icon: <BiCog />             },
  { path: "/ObdReport",      name: "Report",      icon: <BsDatabaseFillDown />},
  { path: "/ObdProfile",     name: "Profile",     icon: <FaUser />            },
  { path: "/ChangePwd",      name: "Pwdchange",   icon: <FaLock />            },
  { path: "/Logout",         name: "Logout",      icon: <AiOutlineLogout />   },
];


const routesclient = [
  {
    path: "/Crm",
    name: "Dashboard",
    icon: <FaHome />,
  },
  {
    path: "/PreviewDialer",
    name: "Preview Dialer",
    icon: <FaListOl />,
  },
  {
    path: "/Callback",
    name: "TodayCallBack",
    icon: <FcCallback />,
  },

  // {
  //   path: "/CallBackall",
  //   name: "AllCallBack",
  //   icon: <FcCallback />,
  // },

  {
    path: "/Agentcalllog",
    name: "Agentcalllog",
    icon: <TbReportSearch />,
  },
  {
    path: "/AgentApr",
    name: "APR Summary",
    icon: <FaChartLine />,
  },
  {
    path: "/Video",
    name: "Video",
    icon: <FaVideo />,
    feature: "jitsi.video",
    exact: true,
    subRoutes: [
      { path: "/Video/Dashboard",  name: "Dashboard",   icon: <FaVideo /> },
      { path: "/Video/NewMeeting", name: "New Meeting", icon: <FaVideo /> },
      { path: "/Video/Escalate",   name: "Escalate Call", icon: <FaVideo /> },
      { path: "/Video/MyRooms",    name: "My Rooms",    icon: <FaVideo /> },
      { path: "/Video/Recordings", name: "Recordings",  icon: <FaVideo /> },
    ],
  },
  {
    path: "/LiveKit/Call",
    name: "LiveKit Calling",
    icon: <FaPhoneVolume />,
    feature: "livekit.calling",
  },
  {
    path: "/Logout",
    name: "Logout",
    icon: <AiOutlineLogout />,
  },
  // {
  //   path: "/saved",
  //   name: "Saved",
  //   icon: <AiFillHeart />,
  // },
];



  

  

  const [islogin, setLogin] = useState(true);
  const [issidebar, setSidebar] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  let history = useNavigate();
  useEffect(() => {
    if (localStorage.getItem('roles')) {
      if (localStorage.getItem('roles') === 'ROLE_USER') {
        setLogin(false)
          setSidebar(true)
        history('/Crm');
      }else {
        setSidebar(true)
        setLogin(false)
        history('/Dashboard');
      }
    } else {
      history('/Dashboard');
      setLogin(true)
      setSidebar(false)
    }
  }, [])


  // One live session per agent (backend AgentLoginGuard): keep this
  // browser's session alive, and log out here if the agent has since
  // logged in from another browser/device.
  useEffect(() => {
    if (islogin) return;
    const role = localStorage.getItem('roles');
    if (role !== 'ROLE_USER' && role !== 'ROLE_AGENT') return;
    if (localStorage.getItem('originalRoles')) return; // impersonating
    let stopped = false;
    const beat = async () => {
      try {
        const res = await fetch(process.env.REACT_APP_IP + "/User/SessionHeartbeat", {
          method: 'POST',
          credentials: 'include',
        });
        if (!res.ok || stopped) return;
        const json = await res.json();
        if (json && json.active === false && !stopped) {
          stopped = true;
          clearToken();
          localStorage.removeItem('token');
          localStorage.removeItem('roles');
          localStorage.removeItem('uid');
          setLogin(true);
          setSidebar(false);
          setCredentials({ username: "", password: "" });
          history('/Dashboard');
          showError("You were logged out: this agent signed in on another browser or device");
        }
      } catch (e) { /* network blip — next beat retries */ }
    };
    beat();
    const t = setInterval(beat, 30000);
    return () => { stopped = true; clearInterval(t); };
  }, [islogin]);

  const [showPassword, setShowPassword] = useState(false);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const [credentials, setCredentials] = useState({ username: "", password: "" })
  const onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value })
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
    const response = await fetch(process.env.REACT_APP_IP + "/authenticate", {
      method: 'POST',
      credentials: 'include', // Accept HttpOnly cookie from backend
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ username: credentials.username, password: credentials.password })
    });
    const json = await response.json()
    if (response.status === 409) {
      // Same agent already logged in on another browser/device.
      showError(json.message || "This agent is already logged in elsewhere")
    } else if (!json.token) {
      showError("Wrong Credential")
    } else if (json.status === 401) {
      showError("Wrong Credential")
    } else {

      if (json.token.length > 10) {
        // Store token in memory (not localStorage) for cross-origin fallback.
        // HttpOnly cookie is primary auth; this is the fallback.
        setToken(json.token);
        localStorage.setItem('roles', json.roles);
        localStorage.setItem('uid', json.id);

        if (localStorage.getItem('roles') === 'ROLE_USER') {
          setLogin(false)
          setSidebar(true)
          history('/Crm');
        } else if (localStorage.getItem('roles') === 'ROLE_IVRUSER') {
          setLogin(false)
          setSidebar(true)
          history('/Dashboard');
        } else {
          setSidebar(true)
          setLogin(false)
          history('/Dashboard');
        }

        // Immediately re-fetch user info so sidebar permissions apply
        // without requiring a page reload.
        refreshUserInfoNow();
        showSuccess("Successfully login")

      } else {
        showError("Wrong Credential")
      }
    }
    } catch (error) {
      showError("Server not reachable")
    }

  }


  const handleLogout = async() => {
    try {
      await fetch(process.env.REACT_APP_IP+"/User/Logout", {
        method: 'POST',
        credentials: 'include',
      });
    } catch (e) { /* ignore logout errors */ }
    clearToken();
    localStorage.removeItem('token');
    localStorage.removeItem('roles');
    localStorage.removeItem('uid');
    setLogin(true)
    setSidebar(false)
    setLogoutConfirming(false)
    setCredentials({username: "", password: ""})
    history('/Dashboard');
    showSuccess("Successfully Logout")
  }

  const [logoutConfirming, setLogoutConfirming] = useState(false);

  const handleLogoutClick = (e) => {
    if (e) e.preventDefault();
    setLogoutConfirming(true);
  }




  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <>

{/* Logout confirmation overlay */}
{logoutConfirming && (
  <div
    onClick={() => setLogoutConfirming(false)}
    style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: '#1e2533',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 14,
        padding: '32px 36px',
        textAlign: 'center',
        boxShadow: '0 8px 40px rgba(0,0,0,0.5)',
        minWidth: 300,
      }}
    >
      <div style={{ fontSize: 44, marginBottom: 8 }}>🔒</div>
      <h5 style={{ color: '#f1f5f9', fontWeight: 700, marginBottom: 6 }}>Sign Out?</h5>
      <p style={{ color: '#94a3b8', fontSize: '0.88rem', marginBottom: 24 }}>
        Are you sure you want to log out?
      </p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
        <button
          onClick={() => setLogoutConfirming(false)}
          style={{
            padding: '9px 24px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.15)',
            background: 'transparent', color: '#94a3b8', fontWeight: 500, cursor: 'pointer',
            fontSize: '0.9rem',
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleLogout}
          style={{
            padding: '9px 24px', borderRadius: 8, border: 'none',
            background: 'linear-gradient(135deg,#ef4444,#dc2626)',
            color: '#fff', fontWeight: 600, cursor: 'pointer',
            fontSize: '0.9rem', boxShadow: '0 2px 8px rgba(239,68,68,0.4)',
          }}
        >
          Yes, Sign Out
        </button>
      </div>
    </div>
  </div>
)}

{islogin &&
<div className="login-page">
  <div className="login-container login-container-simple">
    <div className="login-right-panel">
      <div className="login-form-wrapper">

        <div className="login-form-header">
          <h2>Sign In</h2>
        </div>

        <form onSubmit={handleSubmit} autoComplete="off">

          <label className="login-field-label" htmlFor="username">Username</label>
          <div className="login-input-group">
            <div className="login-input-icon">
              <FaUser size={16} />
            </div>
            <input
              type="text"
              name="username"
              id="username"
              value={credentials.username}
              onChange={onChange}
              placeholder="Enter your username"
              required
            />
          </div>

          <label className="login-field-label" htmlFor="password">Password</label>
          <div className="login-input-group">
            <div className="login-input-icon">
              <FaLock size={16} />
            </div>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              id="password"
              value={credentials.password}
              onChange={onChange}
              placeholder="Enter your password"
              required
            />
            <div
              className="login-eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
            </div>
          </div>

          <button type="submit" className="login-submit-btn">
            Sign In
          </button>

        </form>
      </div>
    </div>
  </div>
</div>
        }


   {issidebar &&
      <div className="main-container">
        <motion.div
          animate={{
            minWidth: isOpen ? "250px" : "50px",

            transition: {
              duration: 0.5,
              type: "spring",
              damping: 10,
            },
          }}
          className={isOpen ? "sidebar" : "hide"}
        >
          <div className="top_section">
            {isOpen && (
              <Link
                to={localStorage.getItem('roles') === 'ROLE_USER' ? '/Crm' : '/'}
                className="sidebar-brand-link"
              >
                <FaHome size={20} />
                <span>{localStorage.getItem('roles') === 'ROLE_USER' ? 'Agent' : 'Call-Center'}</span>
              </Link>
            )}
          </div>
          {/* <div className="search">
            <div className="search_icon">
              <BiSearch />
            </div>
            <AnimatePresence>
              {isOpen && (
                <motion.input
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  variants={inputAnimation}
                  type="text"
                  placeholder="Search"
                />
              )}
            </AnimatePresence>
          </div> */}
          <section className="routes ">


            {localStorage.getItem('roles')==='ROLE_ADMIN'?
            (() => {
              const permSet = new Set(adminPermissions);
              const hasPerms = adminPermissions.length > 0;
              // Paths that always require explicit superadmin grant, even when the
              // admin has no other restrictions (no permissions = full access default).
              const ALWAYS_RESTRICTED = new Set(['/Smssuits', '/SmsportSetting', '/IvrReport']);
              // Paths that are always visible to admins regardless of pagePermissions —
              // self-service screens that show only the admin's own data anyway.
              // ChannelSetting is NOT here (even though it would qualify) —
              // it's a real ADMIN_PAGES catalog entry now, so a superadmin's
              // per-admin permission checkbox is the only gate. Bypassing it
              // here too would make that checkbox meaningless.
              // /LiveKit/Call IS here — it already has its own dedicated
              // SUPERADMIN grant (VoiceBotSettings.liveKitCallingEnabled,
              // toggled from AdminPermissions.jsx, checked via
              // filterRoutes()/feature:"livekit.calling" above). Requiring
              // it in pagePermissions too would mean every existing admin
              // needs a second manual grant for a route that predates their
              // permission list, and would make the dedicated toggle
              // pointless — same reasoning as /VoiceBotQuotas.
              const ALWAYS_ALLOWED = new Set(['/VoiceBotQuotas', '/LiveKit/Call']);
              const allowed = (p) =>
                ALWAYS_ALLOWED.has(p) ? true
                : ALWAYS_RESTRICTED.has(p) ? permSet.has(p)
                : (!hasPerms || permSet.has(p));
              const filtered = filterRoutes(routes)
                .map((route) => {
                  if (route.name === 'Logout') return route;
                  if (route.path === '/settings') {
                    return hasAnyVisibleSettings('ROLE_ADMIN', adminPermissions) ? route : null;
                  }
                  if (route.subRoutes) {
                    const subs = route.subRoutes.filter((s) => allowed(s.permPath || s.path));
                    if (subs.length === 0 && !allowed(route.path)) return null;
                    return { ...route, subRoutes: subs.length ? subs : undefined };
                  }
                  return allowed(route.path) ? route : null;
                })
                .filter(Boolean);
              return filtered.map((route, index) => {
                if (route.subRoutes) {
                  return (
                    <SidebarMenu
                      key={index}
                      setIsOpen={setIsOpen}
                      route={route}
                      showAnimation={showAnimation}
                      isOpen={isOpen}
                    />
                  );
                }
                const isLogout = route.name === 'Logout';
                return (
                  <NavLink
                    key={index}
                    onClick={isLogout ? handleLogoutClick : undefined}
                    to={isLogout ? '#' : route.path}
                    className={isLogout ? "link bg-danger text-white mt-3 mb-5 p-2" : "link"}
                    activeClassName="active"
                  >
                    <div className="icon">{route.icon}</div>
                    <AnimatePresence>
                      {isOpen && (
                        <motion.div
                          variants={showAnimation}
                          initial="hidden"
                          animate="show"
                          exit="hidden"
                          className="link_text"
                        >
                          {route.name}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </NavLink>
                );
              });
            })()
         :""}

{localStorage.getItem('roles')==='ROLE_TEAMLEADER'?
            (() => {
              const permSet = new Set(tlPermissions);
              const allowed = (p) => permSet.has(p);
              const filtered = filterRoutes(routes)
                .map((route) => {
                  // Logout is always visible for TeamLeader regardless of permissions
                  if (route.name === 'Logout') return route;
                  if (route.path === '/settings') {
                    return hasAnyVisibleSettings('ROLE_TEAMLEADER', tlPermissions) ? route : null;
                  }
                  if (route.subRoutes) {
                    const subs = route.subRoutes.filter((s) => allowed(s.permPath || s.path));
                    if (subs.length === 0 && !allowed(route.path)) return null;
                    return { ...route, subRoutes: subs.length ? subs : undefined };
                  }
                  return allowed(route.path) ? route : null;
                })
                .filter(Boolean);
              return filtered.map((route, index) => {
                if (route.subRoutes) {
                  return (
                    <SidebarMenu
                      key={index}
                      setIsOpen={setIsOpen}
                      route={route}
                      showAnimation={showAnimation}
                      isOpen={isOpen}
                    />
                  );
                }
                const isLogout = route.name === 'Logout';
                return (
                  <NavLink
                    key={index}
                    onClick={isLogout ? handleLogout : undefined}
                    to={route.path}
                    className={isLogout ? "link bg-danger text-white mt-3 mb-5 p-2 " : "link"}
                    activeClassName="active"
                  >
                    <div className="icon">{route.icon}</div>
                    <AnimatePresence>
                      {isOpen && (
                        <motion.div
                          variants={showAnimation}
                          initial="hidden"
                          animate="show"
                          exit="hidden"
                          className="link_text"
                        >
                          {route.name}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </NavLink>
                );
              });
            })()
         :""}

{localStorage.getItem('roles')==='ROLE_SUPERADMIN'?
            filterRoutes(routessuperadmin).map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }

              return (
                <>
                <NavLink
                onClick={route.name === 'Logout' ?
                handleLogoutClick:''}
                  to={route.path}
                  key={index}
                  className={route.name === 'Logout' ?
                  "link bg-danger text-white mt-3 mb-5 p-2 ":"link "}
                  activeClassName="active"
                >
                   {route.name === 'Logout' ?
                       <div className="icon" >{route.icon}</div>
                    :   <div className="icon">{route.icon}</div>
                 }
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                       {route.name === 'Logout' ?
                       <div className=''>{route.name}</div>
                       : route.name}
                        
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>


                </>);
            })

         :""}


{localStorage.getItem('roles')==='ROLE_RESELLER'?
            routesreseller.map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    key={index}
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }
              const isLogout = route.name === 'Logout';
              return (
                <NavLink
                  key={index}
                  onClick={isLogout ? handleLogoutClick : undefined}
                  to={isLogout ? '#' : route.path}
                  className={isLogout ? "link bg-danger text-white mt-3 mb-5 p-2" : "link"}
                  activeClassName="active"
                >
                  <div className="icon">{route.icon}</div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                        {route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
              );
            })
         :""}


{localStorage.getItem('roles')==='ROLE_USER'?
            filterRoutes(routesclient).map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }

              return (
                <>
                {route.name === 'Logout' && (
                  <div style={{ borderTop: '1px solid rgba(255,255,255,0.15)', margin: '12px 8px 4px' }} />
                )}
                <NavLink
                 onClick={route.name === 'Logout' ? handleLogoutClick : undefined}
                  to={route.name === 'Logout' ? '#' : route.path}
                  key={index}
                  className={route.name === 'Logout' ? "link bg-danger text-white " : "link "}
                  activeClassName="active"
                >
                   {route.name === 'Logout' ?
                       <div className="icon" >{route.icon}</div>
                    :   <div className="icon">{route.icon}</div>
                 }
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                       {route.name === 'Logout' ? <div>Logout</div> : route.name}

                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
                
                
                </>);
            })
            
         :""}






{localStorage.getItem('roles')==='ROLE_OBDUSER'?
            (() => {
              // Prepend self-serve entries (when granted) in dependency
              // order: Upload Audio → Upload Number → Add Campaign. The
              // campaign needs an approved audio + number list to point at,
              // so the supporting actions come first. The base routes
              // (AddAgent, BlockNumber, Report, Profile, Pwdchange, Logout)
              // stay in their workflow order below.
              const extras = [];
              if (obdUserSelfServe.uploadAudio)  extras.push({ path: "/ObdRecording",    name: "Upload Audio",  icon: <MdOutlineAudioFile /> });
              if (obdUserSelfServe.uploadNumber) extras.push({ path: "/UploadObdNumber", name: "Upload Number", icon: <BsDatabaseFillDown /> });
              if (obdUserSelfServe.campaign)     extras.push({ path: "/AddObdCampaign",  name: "Add Campaign",  icon: <FaRobot /> });
              return [...extras, ...routesobduser];
            })().map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }
              return (
                <>
                <NavLink
                  onClick={route.name === 'Logout' ? handleLogoutClick : ''}
                  to={route.path}
                  key={index}
                  className={route.name === 'Logout' ?
                    "link bg-danger text-white mt-3 mb-5 p-2 " : "link "}
                  activeClassName="active"
                >
                  <div className="icon">{route.icon}</div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                        {route.name === 'Logout' ? <div className=''>{route.name}</div> : route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
                </>);
            })
         :""}

{localStorage.getItem('roles')==='ROLE_OBDADMIN'?
            (() => {
              // Merge granted rows in before Profile/Logout (last 2 entries).
              // Each OBDADMIN_GRANTABLE row appears only if its path is in
              // the user's pagePermissions CSV served by the backend.
              const permSet = new Set(obdAdminPermissions);
              const extras = OBDADMIN_GRANTABLE.filter(r => permSet.has(r.path));

              // Bucket grants by ADMIN_PAGES.group so the sidebar mirrors
              // the way the regular ROLE_ADMIN sidebar nests subRoutes.
              // Without this, granting all 4 IVR pages produced 4 separate
              // top-level rows instead of one "IVR" parent menu.
              const groupOrder = [];
              const groupMap = new Map();
              extras.forEach(e => {
                const g = e.group || '';
                if (!groupMap.has(g)) {
                  groupMap.set(g, []);
                  groupOrder.push(g);
                }
                groupMap.get(g).push(e);
              });
              const groupedExtras = [];
              groupOrder.forEach(g => {
                // 'Settings'-group grants are surfaced only via the Settings
                // hub page (settingsCatalog.js), not as sidebar rows — the
                // flat "/settings" link in routesobdadmin already covers them.
                if (g === 'Settings') return;
                const items = groupMap.get(g);
                const meta = OBDADMIN_GROUP_META[g];
                if (!meta) {
                  // Unknown / 'Main' / empty group → keep flat.
                  items.forEach(it => groupedExtras.push(it));
                } else {
                  groupedExtras.push({
                    path: items[0].path,
                    name: meta.name,
                    icon: meta.icon,
                    exact: true,
                    subRoutes: items.map(it => ({ path: it.path, name: it.name, icon: it.icon })),
                  });
                }
              });

              const tail = Math.max(0, routesobdadmin.length - 2);
              const merged = [
                ...routesobdadmin.slice(0, tail),
                ...groupedExtras,
                ...routesobdadmin.slice(tail),
              ];
              return merged;
            })().map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }
              return (
                <>
                <NavLink
                  onClick={route.name === 'Logout' ? handleLogoutClick : ''}
                  to={route.path}
                  key={index}
                  className={route.name === 'Logout' ?
                    "link bg-danger text-white mt-3 mb-5 p-2 " : "link "}
                  activeClassName="active"
                >
                  <div className="icon">{route.icon}</div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                       {route.name === 'Logout'
                          ? <div className=''>{route.name}</div>
                          : route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
                </>);
            })
         :""}

{localStorage.getItem('roles')==='ROLE_AGENT'?
            routagent.map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }

              return (
                <>
                <NavLink
                onClick={route.name === 'Logout' ?
                handleLogoutClick:''}
                  to={route.path}
                  key={index}
                  className={route.name === 'Logout' ?
                  "link bg-danger ":"link "}
                  activeClassName="active"
                >
                   {route.name === 'Logout' ?
                       <div className="icon" >{route.icon}</div>
                    :   <div className="icon">{route.icon}</div>
                 }
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                       {route.name === 'Logout' ?
                       <div className='' >{route.name}</div>
                       : route.name}
                        
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
                
                
                </>);
            })
            
         :""}





            {/* <NavLink to="/" className="link" onClick={handleLogout}> <AiOutlineLogout className='mx-1' size="20" />Logout</NavLink>  */}
          </section>
          
        </motion.div>

        <div className={isOpen ?
                  "mainmargin":"mainnomargin"}>
            <nav className="navbar navbar-dark bg-primary">
                  <div className="d-flex align-items-center">
                       <span className="navbar-toggler-icon-custom ms-3 me-3" onClick={toggle}><FaBars size={18} /></span>
                       <span className="navbar-brand-text">Call-Center</span>
                  </div>

                  <div className="navbar-right">
                    {showNotification && (
                      <NavLink to="/Callbackactive" className="navbar-callback-badge">
                        <span className="navbar-cb-dot"></span>
                        <FcCallback size={14} />
                        <span>{totalcallback} Callbacks</span>
                      </NavLink>
                    )}
                    <button
                      className="dark-mode-toggle-btn"
                      onClick={() => setDarkMode(!darkMode)}
                      title={darkMode ? "Light Mode" : "Dark Mode"}
                    >
                      {darkMode ? <FaSun size={16} color="#ffc107" /> : <FaMoon size={16} color="#fff" />}
                    </button>
                    <div className="navbar-user">
                      <FaUser size={14} />
                      <span>{usernamed || 'Admin'}</span>
                    </div>
                    <button className="navbar-logout-btn" onClick={handleLogoutClick} title="Logout">
                      <AiOutlineLogout size={18} />
                    </button>
                  </div>
            </nav>
                  {allowWebphone && sipForPhone && sipPassword && (
                    (localStorage.getItem('roles') === 'ROLE_USER') ||
                    (localStorage.getItem('roles') === 'ROLE_ADMIN')
                  ) && (
                    <div className="global-webphone-bar">
                      <WebRTCClient sipUser={`${sipForPhone}-ws`} sipPass={sipPassword} />
                    </div>
                  )}
                  <Breadcrumb />
                  {children}
        </div>

      </div>
}


    </>
  );
};

export default SideBar;
